// extracted by mini-css-extract-plugin
export default {"activityTypeSelect":"ActivityTypes_activityTypeSelect__x9a3A","syncSpecific":"ActivityTypes_syncSpecific__evFSE"};